import { Navbar } from './navbar';
import { Hero } from './hero';
import { FeaturesTabs } from './features-tabs';
import { WhatIsStapel } from './what-is-stapel';
import { FeatureCards } from './feature-cards';
import { Security } from './security';
import { FAQ } from './faq';
import { Footer } from './footer';

export function LandingPage() {
  return (
    <div className="max-w-7xl mx-auto border-x relative">
      <Navbar />
      <main className="flex flex-col items-center justify-center divide-y divide-border min-h-screen w-full">
        <Hero />
        <FeaturesTabs />
        <WhatIsStapel />
        <FeatureCards />
        <Security />
        <FAQ />
        <Footer />
      </main>
    </div>
  );
}
